export const Loading = ({ large = true }) => (
    <div className={`uk-text-center uk-padding${large ? '-large':''} sync`}>
        <i className="fas om-text-black fa-4x fa-circle-notch fa-spin"></i>
        <p className="om-text-black uk-text-lead">Cargando contenido...</p>
    </div>
)